import { AuthenticationService, UserService } from "@nuskin/ns-account";
import { events } from "@nuskin/ns-util";
import axios from "axios";
import Stack from "./service";

let marketConfig, marketLang

function getMarketConfig(component) {
  try {
    const params = new URLSearchParams(window.location.search)
    marketLang = params.get('locale')
    Stack.getConfig('web_account_create_config').then((config) => {
      marketConfig = config
      marketConfig.accountCreateWelcomeUrl = marketConfig.accountCreateWelcomeUrl.replace(
        '$LOCALE$',
        marketLang
      )
      component.enableEmailOptIn = config.enableEmailOptIn
      component.redirectUrl = marketConfig.accountCreateWelcomeUrl
    })
  } catch (e) {
    console.log('Error getting config; ', e)
  }
}

function postGuestCheck(component, data, response) {
  events.publish(events.signup.SIGNUP_WEB_ACCOUNT_CREATE, {
    event: "submit",
    sapId: component.model.sapId,
  });
  let access_token = response.data.access_token;
  let id_token = response.data.id_token;

  if (access_token && id_token) {
    const oktaTokens = {
      accessToken: access_token,
      idToken: id_token,
    };
    AuthenticationService.oktaLogin(oktaTokens, component.model.email);
  } else {
    AuthenticationService.login(data.loginId, data.password);
  }
}

function finishSignup(component) {
  let { clientId, createUrl } = Stack.config.webAccount
  let config = {
    timeout: (40 * 1000),
    headers: {
      'Content-Type': 'application/json',
      'client_id': clientId,
    },
  };

  //convert to encoded URL
  let data = { ...component.model };

  axios.post(createUrl, data, config).then(
    (response) => {
      /* istanbul ignore next */
      if (response.data.status === 200 || response.data.status === '200') {
        postGuestCheck(component, data, response)
      } else {
        component.showErrorToast(response);
        events.publish(events.signup.SIGNUP_WEB_ACCOUNT_CREATE, {
          event: 'error',
          sapId: self.sapId,
        });
      }
    },
    (error) => {
      console.log(error);
      component.showErrorToast(error);
    }
  );

  events.subscribe(events.authentication.PNP_CHECK, () => {
    let redirectUrl = marketConfig.accountCreateWelcomeUrl;

    /* istanbul ignore else */
    if (!marketConfig.skipSignonRedirect) {
      let destinationURL = marketConfig.NUSKIN_URL + marketConfig.accountCreateWelcomeUrl;
      redirectUrl = escape(destinationURL);
      component.redirectUrl =
        marketConfig.NUSKIN_URL +
        "/signon/pnp/form.do?pnpSapId=" +
        UserService.getUser().id +
        "&pnpLang=en&pnpAcceptURL=" +
        redirectUrl +
        "&pnpRejectURL=" +
        redirectUrl +
        "&pnpErrorURL=" +
        redirectUrl;
    }
    component.showSuccessToast();
  });

  events.subscribe(events.authentication.LOGIN_COMPLETE, () => {
    component.showSuccessToast();
  });
}

export default {
  finishSignup,
  getMarketConfig: getMarketConfig,
  postGuestCheck,
};
